
import photoAlice from '../../img/reviews/reviewFem1.webp';
import photoCarla from '../../img/reviews/reviewFem2.webp';
import photoEva from '../../img/reviews/reviewFem3.webp';
import photoBruno from '../../img/reviews/reviewMas1.webp';
import photoDaniel from '../../img/reviews/reviewMas2.webp';





const Reviews = [
    { id: 1, name: "Alice", photo: photoAlice, review: "Gosto muito da academia ambinte acolhedor." ,stars: 4.5},
    { id: 2, name: "Bruno", photo: photoBruno, review: "Os instrutores são muito atenciosos e profissionais.", stars: 5 },
    { id: 3, name: "Carla", photo: photoCarla, review: "A variedade de equipamentos é excelente!" , stars: 4 },
    { id: 4, name: "Daniel", photo: photoDaniel, review: "Adoro as aulas em grupo, são muito motivadoras.", stars: 4.8 },
    { id: 5, name: "Eva", photo: photoEva, review: "O ambiente é limpo e bem organizado.", stars: 3.8 },
];

export default Reviews;